var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 d-flex align-items-center justify-content-center"},[_c('div',{staticClass:"d-flex flex-column"},[_c('div',{staticClass:"text-center"},[_c('h1',[_vm._v(_vm._s(_vm.$t('views.notFound.title')))]),_c('p',[_vm._v(" "+_vm._s(_vm.$t('views.notFound.description')))])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }